module.exports = __webpack_public_path__ + "img/zj2.ec551d8f.png";